import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isToday from 'dayjs/plugin/isToday';
import isTomorrow from 'dayjs/plugin/isTomorrow';
import type { RangePickerProps } from 'antd/es/date-picker';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isToday);
dayjs.extend(isTomorrow);

export const disabledDate: RangePickerProps['disabledDate'] = (current) => {
  return current && current < dayjs().startOf('day');
};

export const getToday = () => dayjs().locale('ru-RU');

export const getTomorrow = () => dayjs().add(1, 'day').locale('ru-RU');

export const getIsToday = (date?: string): boolean => dayjs(date).locale('ru-RU').isToday();

export const getIsTomorrow = (date?: string): boolean => dayjs(date).locale('ru-RU').isTomorrow();
